import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {t} from 'react-switch-lang';
import './OccurrenceModal.scss';
import * as yup from 'yup';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {
  addKeyRiskOccurrence,
  getKeyRiskOccurrence,
  editKeyRiskOccurrence, getKeyRisk,
} from '../../../../services/keyRiskIndicatorsService';
import Toast from '../../../../components/toast/Toast';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';
import TextArea from '../../../../components/FormFields/Textarea';
import Swal from "sweetalert2";
import {format} from 'date-fns';
import InputText from '../../../../components/FormFields/InputText';
import {validDouble} from '../../../../utils/const';

const OccurrenceModal = ({title, isOpen, isClosed, keyId, updateTable, tableRowId, escPressed}) => {

  const [modal, setModal] = useState(false);
  const [keyRiskOccurrence, setKeyRiskOccurrence] = useState([]);
  const [escalationCalculationType, setEscalationCalculationType] = useState([]);
  const toggle = () => setModal(!modal);

  const fetchKeyRiskOccurrence = async () => {
    try {
      const {data} = await getKeyRiskOccurrence(tableRowId);
      setKeyRiskOccurrence(data);
    } catch (e) {
    }
  };
  const fetchEscalationCalculationType = async () => {
    try {
      const {data} = await getKeyRisk(keyId);
      setEscalationCalculationType(data?.escalationCalculationType);
    } catch (e) {
    }
  };

  useEffect(() => {
    setModal(isOpen);
    /*** When editing ***/
    if (tableRowId) {
      fetchKeyRiskOccurrence();
    }
    if (keyId) {
      fetchEscalationCalculationType()
    }
  }, []);



  const schema = yup.object().shape({
    dateOfOccurrence: yup.string().required(t('message.fieldRequired')),
    value:
      escalationCalculationType !== 'COUNTER'
        ? yup
          .string()
          .trim()
          .required(t('message.fieldRequired'))
          .matches(validDouble, t('message.onlyDecimalNumbersMinZero'))
          .typeError(t('message.onlyDecimalNumbersMinZero'))
        : yup.string().nullable(),
    description: yup.string().nullable().required(t('message.fieldRequired')).max(1000, t('message.max', {max: 1000}))
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit} = methods;

  // TO-DO add keyIndicatorIndicatorNameEn on backend
  const onSubmit = async (e) => {
    /*** When adding new risk occurrence ***/
    if (!tableRowId) {
      const body = {
        'dateOfOccurrence': format(new Date(e.dateOfOccurrence), "yyyy-MM-dd'T'HH:mm:ss"),
        'description' : e.description,
        'value': e?.value ? e?.value : null,
        'keyIndicatorId': keyId
      };
      try {
        const response = await addKeyRiskOccurrence(body);
        if (response.status === 201) {
          updateTable();
          Toast.fire({
            title: t('Pages.messages.addSuccess2',
              {entity: t('Pages.common.keyRiskIndicatorOccurrence')}),
            icon: 'success'
          });
          toggle();
          isClosed();
        }
      } catch (err) {
        Swal.fire({
          text: t('Pages.messages.addError',
            {entity: t('Pages.common.keyRiskIndicatorOccurrence2')}),
          icon: 'error',
        });
        toggle();
        isClosed();
      }
    } else {
      /*** When editing risk occurrence ***/
      const body = {
        'dateOfOccurrence': new Date(e.dateOfOccurrence),
        'description' : e.description,
        'id': keyRiskOccurrence['id'],
        'value': e?.value ? e?.value : null,
        'keyIndicatorId': keyRiskOccurrence['keyIndicatorId'],
      };
      try {
        const response = await editKeyRiskOccurrence(body);
        if (response.status === 200) {
          updateTable();
          Toast.fire({
            title: t('Pages.messages.updateSuccess2',
              {entity: t('Pages.common.keyRiskIndicatorOccurrence')}),
            icon: 'success'
          });
          toggle();
          isClosed();
        }
      } catch (err) {
        Swal.fire({
          text: t('Pages.messages.updateError',
            {entity: t('Pages.common.keyRiskIndicatorOccurrence2')}),
          icon: 'error',
        });
        toggle();
        isClosed();
      }
    }
  };

  return (
    <div onKeyDown={e => {if (e.keyCode === 27) {escPressed(true)}}}>
      <Modal isOpen={modal} toggle={toggle} backdrop={false} className="modal-md key">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} spellCheck="false">
            <ModalHeader toggle={() => {
              toggle();
              isClosed();
            }}>{title}</ModalHeader>
            <ModalBody>
              <div>
                <div className="pt-4 pb-4">
                  <div className="d-flex flex-column mb-4">
                    <label htmlFor="dateOfOccurrence">{t('Pages.ViewKeyRiskIndicator.dateOfOccurrence')}</label>
                    <InputDate name="dateOfOccurrence"
                               key={keyRiskOccurrence}
                               defaultValue={tableRowId ? keyRiskOccurrence['dateOfOccurrence'] : new Date()}
                               style={{width: '100%'}}
                               maxDate={new Date()}/>
                  </div>
                  {escalationCalculationType !== 'COUNTER' &&
                  <div className="d-flex flex-column mb-4">
                    <label className="label" htmlFor="value">
                      {t('Pages.ViewKeyRiskIndicator.value')}
                    </label>
                    <InputText
                      name="value"
                      type="number"
                      className="form-control"
                      placeholder={t("Pages.ViewKeyRiskIndicator.placeholderValue")}
                      defaultValue={tableRowId ? keyRiskOccurrence['value'] : null}
                    />
                  </div>}
                  <div className="d-flex flex-column mb-4">
                    <label htmlFor="descriptionMne">{t('Pages.ViewKeyRiskIndicator.descriptionOccurrenceMne')}</label>
                    <TextArea name="description" defaultValue={tableRowId ? keyRiskOccurrence['description'] : null}/>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="secondary-btn" onClick={(e) => {
                e.preventDefault();
                toggle();
                isClosed();
              }}>{t('common.cancel')}</button>
              <button type="submit" className="primary-btn align-items-center d-flex">{t('common.save')}</button>
            </ModalFooter>
          </form>
        </FormProvider>
      </Modal>
    </div>
  );
};

export default OccurrenceModal;